<div id="<%= dom_id studio %>">
    <div class="flex justify-between items-center">
      <h1 class="mx-auto font-bold text-4xl pb-5"><%= studio.name %></h1>
    </div>

    <table class="table-fixed mx-auto">
    <thead>
      <tr>
        <td class="row-head">Name
        <td class="row-head">Type
        <% if studio.id > 0 %>
        <td class="row-head">Role
        <td class="row-head">Level
        <% end %>
      </tr>
    </thead>
    <tbody>
    <% studio.people.sort_by(&:name).each do |person| %>
      <tr>
        <td class="row-main"><%= link_to person.name, person %></td>
        <td class="row"><%= person.type %></td>
        <% if studio.id > 0 %>
        <td class="row"><%= person.role %></td>
        <td class="row"><%= person.level&.name %></td>
        <% end %>
      </tr>
    <% end %>
    </tbody>
    </table>

  <% if action_name != "show" %>
    <%= link_to "Show this studio", studio, class: "rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium" %>
    <%= link_to 'Edit this studio', edit_studio_path(studio), class: "rounded-lg py-3 ml-2 px-5 bg-gray-100 inline-block font-medium" %>
    <hr class="mt-6">
  <% end %>
</div>
